import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import Chats from "../../services/chat.service";
import SingleChat from "./single_chat";
import NewTicket from "./new_ticket";
import NewMessage from "./new_message";
import Events from '../../services/events.service'
import "./chat.scss";

export default class Chat extends Subscriber {
  state = {
    expanded: false,
    open_ticket: null,
    ready: false,
    ticket: null
  };

  init = () => {

    this.subscriptions.push(
      Storage.get_obsrv("account_id").subscribe(id => {
        if (id) {
          Chats.setUserData();
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("session").subscribe(id => {
        if (id && !Storage.get("account_id")) {
          Chats.connectUser(id);
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("bird_connected").subscribe(connected => {
        if (connected) {
          // Chats.checkIfUserIsOnline(Storage.get("uid"));
          // Chats.getOrCreateTicket();
          Chats.getTicket();
          //Chats.retrieveClosedTickets();
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("ticket").subscribe(open_ticket => {
        this.setState({
          open_ticket: open_ticket
        });
        if (open_ticket) {
          Chats.activateOpenTicket();
        }
      })
    );

    this.setState({
      ready: true
    });
  };

  componentDidMount() {
    let business = Storage.get("businessConfig");
    let delay = business && business["web_chat_delay"] ? business["web_chat_delay"] : 0;
    setTimeout(() => {
      Chats.init();
      this.init();
    }, delay);

    this.subscriptions.push(
      Storage.get_obsrv("active_ticket").subscribe(ticket => {
        this.setState({
          ticket: ticket ? true : false
        });
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("start_chat").subscribe(data => {
        if (data) {
          this.setState({
            expanded: true
          });
          Storage.clear("start_chat");
        }
        // Storage.clear("error");
        // Storage.clear("error");
        // Storage.clear("payment_processing");
        // Storage.clear("processing_cybersouce");
      })
    );

  }
  shouldComponentUpdate(nextState) {
    if (nextState.ready !== this.state.ready) {
      return true;
    }
    return false;
  }
  toggleChat = () => {
    Events.when_user_interacts_with_sendBird("agent_chat_widget_clicked")
    this.setState({
      expanded: !this.state.expanded
    });
  };

  tabChange = () => {};

  render() {
    let classes = "";
    if (this.state.expanded) {
      classes = "expanded";
    }
    if(window.location.hash === '#/payment'){
      classes = 'hidden'
    }
    let content = "";

    if (this.state.ready) {
      content = (
        <>
          <div
            className={"chat_trigger floater " + classes}
            onClick={this.toggleChat}
          />
          {this.state.expanded ? (
            <div className="chat_window">
              <h3> Web chat </h3>

              {this.state.open_ticket ? (
                <div className="chat_window_inner">
                  <SingleChat />
                </div>
              ) : (
                <div className="chat_window_inner">
                  <NewTicket />
                </div>
              )}
              <NewMessage />
            </div>
          ) : (
            ""
          )}
        </>
      );
    }

    return content;
  }
}